import { Project } from '@bulthaup/api/db';
import { Group, Switch, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { trpc } from '../../../../../services/trpc';

export function TechnicalPlanVerifiedOnSiteSection({
  project,
}: {
  project: Project;
}) {
  const utils = trpc.useUtils();

  const update = trpc.projects.updateTechnicalPlanVerifiedOnSite.useMutation({
    onSuccess: () => {
      notifications.show({
        title: 'Succès',
        message: 'Plan technique vérifié sur chantier mise à jour',
        color: 'green',
      });
      utils.projects.get.invalidate({ slug: project.slug });
    },
    onError: error => {
      notifications.show({
        title: 'Erreur',
        message: error.message,
        color: 'red',
      });
    },
  });

  const handleToggle = async (checked: boolean) => {
    await update.mutateAsync({
      id: project.id,
      isTechnicalPlanVerifiedOnSite: checked,
    });
  };

  return (
    <Group justify="space-between">
      <Text>Plan technique vérifié sur chantier :</Text>
      <Switch
        color="green"
        checked={project.isTechnicalPlanVerifiedOnSite}
        onChange={event => handleToggle(event.currentTarget.checked)}
        disabled={update.isPending}
      />
    </Group>
  );
}
